import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { Button, UncontrolledTooltip, FormGroup, Input } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashCan } from '@fortawesome/free-solid-svg-icons';
import ImagePopup from '../../../components/common/imagePopup';
import VideoPopup from '../../../components/common/VideoPopup';

const GridItem = (props: {
  screen: {
    _id: string;
    component: {
      _id: string;
      name: string;
    };
    prototype: {
      _id: string;
      name: string;
    };
    image_path: string;
    video_path: string;
    video_poster_path: string;
    mediaType: string;
    url: string;
    note: string;
    created_at: string;
    user: {
      _id: string;
      email: string;
      first_name: string;
      last_name: string;
      picture: string;
    };
    tags: [
      {
        _id: string;
        name: string;
      },
    ];
    is_legacy?: boolean;
  };
  onDelete: Function;
  onToggleLegacy?: Function;
  itemKey: string;
}) => {
  const { screen, onDelete: handleDelete, onToggleLegacy, itemKey } = props;
  let note = screen.note || '-';
  const [displayShowMore] = useState(note.length > 50);
  const [showMore, setShowMore] = useState(false);
  const [isLegacy, setIsLegacy] = useState(screen.is_legacy || false);

  const handleShowMore = (event: any) => {
    event.preventDefault();
    setShowMore(!showMore);
  };

  if (note.length > 50) {
    note = showMore ? note : note.substring(0, 50);
  }

  const handleLegacyToggle = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.checked;
    setIsLegacy(newValue);
    if (onToggleLegacy) {
      /* eslint-disable no-underscore-dangle */
      onToggleLegacy(screen._id, newValue);
      /* eslint-enable */
    }
  };

  useEffect(() => {
    setIsLegacy(screen.is_legacy || false);
  }, [screen.is_legacy]);

  return (
    <div className="ar-common-post">
      {screen.mediaType === 'video' ? (
        <VideoPopup
          posterPath={screen.video_poster_path}
          videoPath={screen.video_path}
        />
      ) : (
        <ImagePopup image={screen.image_path} mobileImage={undefined} />
      )}
      <div className="ar-common-post__container">
        <div className="ar-common-post__cat">
          URL:{' '}
          {isLegacy ? (
            'N/A'
          ) : (
            <a
              className="ar-common-post__link"
              href={screen.url}
              target="_blank"
              rel="noopener noreferrer"
              title={screen.url}
              style={{ width: 'fit-content' }}
            >
              {screen.url.length > 25
                ? `${screen.url.substring(0, 25)}...`
                : `${screen.url ? screen.url : 'N/A'}`}
            </a>
          )}
        </div>
        <div className="ar-common-post__cat">
          Prototype:
          <span>{` ${screen.prototype?.name || 'Not Specified'}`}</span>
        </div>
        <div className="ar-common-post__cat">
          Section Type:
          <span>{` ${screen.component?.name || 'N/A'}`}</span>
        </div>
        <div className="ar-common-post__cat">
          Added By:
          <span>
            {` ${screen.user.first_name} ${screen.user.last_name}`} on{' '}
            {moment(screen.created_at).format('MM/DD/YYYY')}
          </span>
        </div>
        <div className="ar-common-post__cat">
          Tags:
          {screen.tags ? (
            <>
              {screen.tags.map((tag) => (
                <span className="ar-common-post__tag" key={Math.random()}>
                  {tag.name}
                </span>
              ))}
            </>
          ) : null}
        </div>
        <div className="ar-common-post__cat">
          Note:
          <p>
            {`${note} `}
            {displayShowMore && [
              /* eslint-disable-next-line jsx-a11y/anchor-is-valid */
              <a href="#" onClick={handleShowMore}>
                Show {showMore ? 'less' : 'more'}
              </a>,
            ]}
          </p>
        </div>
        <div className="ar-common-post__action">
          <FormGroup
            check
            className="mb-0"
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Input
              type="checkbox"
              id={`legacy-${itemKey}`}
              checked={isLegacy}
              onChange={handleLegacyToggle}
              style={{
                width: '18px',
                height: '18px',
                padding: '5px',
                margin: '0 5px 0 0',
              }}
            />
            <UncontrolledTooltip
              placement="bottom"
              target={`legacy-${itemKey}`}
            >
              Toggle Legacy Status
            </UncontrolledTooltip>
          </FormGroup>
          <Button
            id={`delete-${itemKey}`}
            className="ar-btn ar-btn--primary-delete"
            color="link"
            /* eslint-disable no-underscore-dangle */
            onKeyDown={() => handleDelete(screen._id)}
            onClick={() => handleDelete(screen._id)}
            /* eslint-enable */
          >
            <FontAwesomeIcon icon={faTrashCan} />
          </Button>
          <UncontrolledTooltip placement="bottom" target={`delete-${itemKey}`}>
            Delete
          </UncontrolledTooltip>
        </div>
      </div>
    </div>
  );
};

GridItem.defaultProps = {
  onToggleLegacy: undefined,
};
export default GridItem;
